import { render } from "./invoice.vue?vue&type=template&id=94209974&scoped=true&ts=true"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"

import "./invoice.vue?vue&type=style&index=0&id=94209974&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94209974"]])

export default __exports__